module.exports = __webpack_public_path__ + "static/media/5S.8f300fb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5S.svg
// module id = 68
// module chunks = 0